import getQueryString from 'Common/getQueryString';
import { getDisplay, getAndFormat } from 'Common/formValues';
import * as R from 'ramda';

export default form => {
  const values = form.values;
  let queryItems = getQueryString(form).split('&');
  let url;
  if (values.dealerId) {
    url = 'dealer/' + getDisplay(values.dealerId);
    queryItems = queryItems.filter(i => !R.startsWith('dealer.id', i));
  } else {
    if (values.make) {
      url = getAndFormat(values.make);
      queryItems = queryItems.filter(i => !R.startsWith('derivative.make', i));
    } else {
      url = 'all';
    }
    if (values.model) {
      url = url + '/' + getAndFormat(values.model);
      queryItems = queryItems.filter(i => !R.startsWith('derivative.range', i));
    }

    if (values.category && !values.make && !values.model) {
      url = getAndFormat(values.category);
      queryItems = queryItems.filter(
        i => !R.startsWith('derivative.category', i)
      );
    }
  }

  queryItems = queryItems.filter(
    i => !(R.startsWith('lat', i) || R.startsWith('long', i))
  );
  const query = queryItems.join('&');
  return '/used-cars/' + url + '?' + query;
};



// WEBPACK FOOTER //
// ./src/Common/buildUrlFromForm/index.js